import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "../../actions/actionTypes";
import { ManagerDashboardAction } from "../../actions";
import * as DashboardApi from "../../api/dashboard/managerDashboard";
import { SetMessage } from "../../assets/errorMessages";

export function* watcherManagerDashboard() {
  yield takeLatest(
    types.MANAGER_DASHBOARD_GET_PENDING_LIST_REQUEST,
    workerManagerPendingList
  );
  yield takeLatest(
    types.MANAGER_DASHBOARD_GET_CUSTODIAN_BALANCE_REQUEST,
    workerManagerCustodianBalance
  );
  yield takeLatest(
    types.MANAGER_DASHBOARD_GET_CLASSIFICATION_REQUEST,
    workerManagerClassification
  );
}

function fetchManagerPendingList() {
  return DashboardApi.managerGetPendingList();
}
function* workerManagerPendingList() {
  try {
    const response = yield call(fetchManagerPendingList);
    let data = response.data;
    yield put(ManagerDashboardAction.managerGetPendingListSuccess(data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerDashboardAction.managerGetPendingListFailure(message));
  }
}

function fetchManagerCustodianBalance() {
  return DashboardApi.managerGetCustodianBalance();
}
function* workerManagerCustodianBalance() {
  try {
    const response = yield call(fetchManagerCustodianBalance);
    let data = response.data;
    yield put(
      ManagerDashboardAction.managerGetCustodianBalanceSuccess(data.data)
    );
  } catch (error) {
    const message = SetMessage(error);
    yield put(
      ManagerDashboardAction.managerGetCustodianBalanceFailure(message)
    );
  }
}

function fetchManagerClassification() {
  return DashboardApi.managerGetClassification();
}
function* workerManagerClassification() {
  try {
    const response = yield call(fetchManagerClassification);
    let data = response.data;
    yield put(
      ManagerDashboardAction.managerGetClassificationSuccess(data.data)
    );
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerDashboardAction.managerGetClassificationFailure(message));
  }
}
